import Vue from 'vue'

const EventDispatcher = new Vue()

export default EventDispatcher
